import { IpAddress, IpVersion } from "../Core/IpAddress";
import { MacAddress } from "../Core/MacAddress";
import { IpNetMask, NetMaskType } from "../Core/IpNetMask";
import { StringUtils } from "../Utils/StringUtils";
import { HashSet } from "../Utils/HashSet";
import { List } from "../Utils/List";
import { Device } from "../Core/Device";
import { InfoSet } from "../InfoSets/InfoSet";
import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ObjSerUtils } from "../Serialization/ObjSerUtils";
import { ValueEncoder } from "../Utils/ValueEncoder";

//export interface Win32_NetworkAdapterConfigEntryJson {
//    index: string;
//    caption: string;
//    default_ip_gateways: string[];
//    description: string;
//    dhcp_enabled: boolean;
//    dhcp_lease_expires: string;
//    dhcp_lease_obtained: string;
//    dhcp_server: string;
//    dns_domain: string;
//    dns_domain_suffix_search_order: string;
//    dns_host_name: string;
//    dns_server_search_order: string;
//    if_index: string;
//    ip_addresses: string[];
//    ip_subnet_masks: string[];
//    mac_address: string;
//}

//export interface Win32_NetworkAdapterConfigEntryJsonWrapper {
//	win32_network_adapter_config_entry: Win32_NetworkAdapterConfigEntryJson;
//}

export class Win32_NetworkAdapterConfigEntry implements ObjectSerializer {
	//public Deserialize(json: Win32_NetworkAdapterConfigEntryJson):void {

	//       this.Index = parseInt(json.index);
	//	this.Caption = json.caption;
	//	this.Description = json.description;
	//	this.DHCPEnabled = json.dhcp_enabled;
	//	this.DHCPLeaseExpires = new Date(json.dhcp_lease_expires);
	//	this.DHCPLeaseObtained = new Date(json.dhcp_lease_obtained);
	//	this.DHCPServer = IpAddress.Create(json.dhcp_server);
	//	this.DNSDomain = json.dns_domain;
	//	this.DNSHostName = json.dns_host_name;
	//	this.DNSServerSearchOrder = json.dns_server_search_order;
	//	this.InterfaceIndex = parseInt(json.if_index);
	//	this.MacAddress = MacAddress.CreateFromString(json.mac_address);

	//       if (json.default_ip_gateways !== undefined) {
	//           json.default_ip_gateways.forEach((ipJson: any) => {
	//               this.DefaultIPGateways.Add(IpAddress.Create(<string>ipJson.ip_address));
	//           });
	//       }

	//	if (json.ip_addresses !== undefined) {
	//	    json.ip_addresses.forEach((ipJson: any) => {
	//	        this.IPAddresses.Add(IpAddress.Create(<string>ipJson.ip_address));
	//	    });
	//	}

	//	if (json.ip_subnet_masks !== undefined) {
	//	    json.ip_subnet_masks.forEach((netMaskJson: any) => {
	//	        if (netMaskJson.entry.net_mask !== undefined)
	//	            this.IPSubnetMasks.Add(IpNetMask.Create(IpAddress.Create(<string>netMaskJson.entry.net_mask)));

	//	        if (netMaskJson.entry.net_mask_length !== undefined)
	//	            this.IPSubnetMasks.Add(IpNetMask.CreateFromVersion(IpVersion.IPv6, parseInt(<string>netMaskJson.entry.net_mask_length)));
	//	});
	//	}
	//}

	public Caption: string;
	public get HasCaption(): boolean {
		return !StringUtils.IsNullOrEmpty(this.Caption);
	}

	public DefaultIPGateways: HashSet<IpAddress>;
	public get HasDefaultIPGateways(): boolean {
		if (this.DefaultIPGateways == null)
			return false;
		if (this.DefaultIPGateways.Count <= 0)
			return false;
		return true;
	}

	public Description: string;
	public get HasDescription(): boolean {
		return !StringUtils.IsNullOrEmpty(this.Description);
	}

	public DHCPEnabled: boolean;
	public get IsDHCPEnabled(): boolean {
		return this.DHCPEnabled;
	}

	public DHCPLeaseExpires: Date
	public get HasDHCPLeaseExpires(): boolean {
		if (this.DHCPLeaseExpires == null)
			return false;
		if (this.DHCPLeaseExpires.getTime() <= 0)
			return false;
		return true;
	}

	public DHCPLeaseObtained: Date
	public get HasDHCPLeaseObtained(): boolean {
		if (this.DHCPLeaseObtained == null)
			return false;
		if (this.DHCPLeaseObtained.getTime() <= 0)
			return false;
		return true;
	}

	public DHCPServer: IpAddress;
	public get HasDHCPServer(): boolean {
		if (this.DHCPServer == null)
			return false;
		return (this.DHCPServer.IsValidDiscoveryAddress);
	}

	public DNSDomain: string;
	public get HasDNSDomain(): boolean {
		return !StringUtils.IsNullOrEmpty(this.DNSDomain);
	}

	public DNSDomainSuffixSearchOrder: string
	public get HasDNSDomainSuffixSearchOrder(): boolean {
		return !StringUtils.IsNullOrEmpty(this.DNSDomainSuffixSearchOrder);
	}

	public DNSHostName: string;
	public get HasDNSHostName(): boolean {
		return !StringUtils.IsNullOrEmpty(this.DNSHostName);
	}


	public DNSServerSearchOrder: string;
	public get HasDNSServerSearchOrder(): boolean {
		return !StringUtils.IsNullOrEmpty(this.DNSServerSearchOrder);
	}


	public Index: number;
	public get HasIndex(): boolean {
		if (this.Index >= 0)
			return true;
		return false;
	}

	public InterfaceIndex: number;
	public get HasInterfaceIndex(): boolean {
		if (this.InterfaceIndex >= 0)
			return true;
		return false;
	}

	public IPAddresses: HashSet<IpAddress>;
	public get HasIPAddresses(): boolean {
		if (this.IPAddresses == null)
			return false;
		if (this.IPAddresses.Count <= 0)
			return false;
		return true;
	}


	public IPSubnetMasks: HashSet<IpNetMask>;
	public get HasIPSubnetMasks(): boolean {
		if (this.IPSubnetMasks == null)
			return false;
		if (this.IPSubnetMasks.Count <= 0)
			return false;
		return true;
	}

	public MacAddress: MacAddress;
	public get HasMacAddress(): boolean {

		if (this.MacAddress == null)
			return false;
		if (this.MacAddress.IsNull)
			return false;
		return true;
	}

	constructor() {
		this.Init();
	}

	private Init(): void {
		this.Caption = "";
		this.DefaultIPGateways = new HashSet<IpAddress>();
		this.Description = "";
		this.DHCPEnabled = false;
		this.DHCPLeaseExpires = new Date(0);
		this.DHCPLeaseObtained = new Date(0);
		this.DHCPServer = null;
		this.DNSDomain = "";
		this.DNSDomainSuffixSearchOrder = "";
		this.DNSHostName = "";
		this.DNSServerSearchOrder = "";
		this.Index = -1;
		this.InterfaceIndex = -1;
		this.IPAddresses = new HashSet<IpAddress>();
		this.IPSubnetMasks = new HashSet<IpNetMask>();
		this.MacAddress = null;
	}

	public Write(obj: any, context: any): void {
		obj.win32_network_adapter_config_entry = {};
		obj = obj.win32_network_adapter_config_entry;

		obj.index = ValueEncoder.EncodeInteger(this.Index);

		if (this.HasCaption)
			obj.caption = this.Caption;
		if (this.HasDefaultIPGateways) {
			obj.default_ip_gateways = [];
			ObjSerUtils.WriteCollection(obj.default_ip_gateways, this.DefaultIPGateways,
				(value: IpAddress) => {
					return { ip_address: ValueEncoder.EncodeIpAddress(value) };
				}, context);
		}
		if (this.HasDescription)
			obj.description = this.Description;
		obj.dhcp_enabled = ValueEncoder.EncodeBoolean(this.DHCPEnabled);
		if (this.HasDHCPLeaseExpires)
			obj.dhcp_lease_expires = ValueEncoder.EncodeDateTime(this.DHCPLeaseExpires);
		if (this.HasDHCPLeaseObtained)
			obj.dhcp_lease_obtained = ValueEncoder.EncodeDateTime(this.DHCPLeaseObtained);
		if (this.HasDHCPServer)
			obj.dhcp_server = ValueEncoder.EncodeIpAddress(this.DHCPServer);
		if (this.HasDNSDomain)
			obj.dns_domain = this.DNSDomain;
		if (this.HasDNSDomainSuffixSearchOrder)
			obj.dns_domain_suffix_search_order = this.DNSDomainSuffixSearchOrder;
		if (this.HasDNSHostName)
			obj.dns_host_name = this.DNSHostName;
		if (this.HasDNSServerSearchOrder)
			obj.dns_server_search_order = this.DNSServerSearchOrder;
		if (this.HasInterfaceIndex)
			obj.if_index = ValueEncoder.EncodeInteger(this.InterfaceIndex);
		if (this.HasIPAddresses) {
			obj.ip_addresses = [];
			ObjSerUtils.WriteCollection(obj.ip_addresses, this.IPAddresses,
				(value: IpAddress) => {
					return { ip_address: ValueEncoder.EncodeIpAddress(value) };
				}, context);
		}
		if (this.HasIPSubnetMasks) {
			obj.ip_subnet_masks = [];
			ObjSerUtils.WriteCollection(obj.ip_subnet_masks, this.IPSubnetMasks,
				(value: IpNetMask) => {
					if (value.MaskType == NetMaskType.IpAddress) {
						return {
							entry: {
								net_mask: ValueEncoder.EncodeIpAddress(value.MaskAddress)
							}
						};
					}
					else {
						return {
							entry: {
								net_mask_length: ValueEncoder.EncodeInteger(value.MaskLength)
							}
						};
					}
				}, context);
		}
		if (this.HasMacAddress)
			obj.mac_address = ValueEncoder.EncodeMacAddress(this.MacAddress);
	}

	public Read(obj: any, context: any): void {
		if (!obj.win32_network_adapter_config_entry)
			throw new Error();
		obj = obj.win32_network_adapter_config_entry;

		if (obj.index !== undefined)
			this.Index = ValueEncoder.DecodeInteger(obj.index);
		if (obj.caption !== undefined)
			this.Caption = obj.caption;
		if (obj.default_ip_gateways !== undefined) {
			ObjSerUtils.ReadCollection(obj.default_ip_gateways, this.DefaultIPGateways,
				(value: any) => {
					return ValueEncoder.DecodeIpAddress(value.ip_address);
				}, context);
		}
		if (obj.description !== undefined)
			this.Description = obj.description;
		if (obj.dhcp_enabled !== undefined)
			this.DHCPEnabled = ValueEncoder.DecodeBoolean(obj.dhcp_enabled);
		if (obj.dhcp_lease_expires !== undefined)
			this.DHCPLeaseExpires = ValueEncoder.DecodeDateTime(obj.dhcp_lease_expires);
		if (obj.dhcp_lease_obtained !== undefined)
			this.DHCPLeaseObtained = ValueEncoder.DecodeDateTime(obj.dhcp_lease_obtained);
		if (obj.dhcp_server !== undefined)
			this.DHCPServer = ValueEncoder.DecodeIpAddress(obj.dhcp_server);
		if (obj.dns_domain !== undefined)
			this.DNSDomain = obj.dns_domain;
		if (obj.dns_domain_suffix_search_order !== undefined)
			this.DNSDomainSuffixSearchOrder = obj.dns_domain_suffix_search_order;
		if (obj.dns_host_name !== undefined)
			this.DNSHostName = obj.dns_host_name;
		if (obj.dns_server_search_order !== undefined)
			this.DNSServerSearchOrder = obj.dns_server_search_order;
		if (obj.if_index !== undefined)
			this.InterfaceIndex = ValueEncoder.DecodeInteger(obj.if_index);
		if (obj.ip_addresses !== undefined) {
			ObjSerUtils.ReadCollection(obj.ip_addresses, this.IPAddresses,
				(value: any) => {
					return ValueEncoder.DecodeIpAddress(value.ip_address);
				}, context);
		}
		if (obj.ip_subnet_masks !== undefined) {
			ObjSerUtils.ReadCollection(obj.ip_subnet_masks, this.IPSubnetMasks,
				(value: any) => {
					if (value.entry.net_mask !== undefined)
						return IpNetMask.Create(ValueEncoder.DecodeIpAddress(value.entry.net_mask));
					else if (value.entry.net_mask_length !== undefined)
						return IpNetMask.CreateFromVersion(IpVersion.IPv6, ValueEncoder.DecodeInteger(value.entry.net_mask_length));
					else
						throw new Error("Invalid subnet mask in win32_network_adapter_config_entry");
				}, context);
		}
		if (obj.mac_address !== undefined)
			this.MacAddress = MacAddress.CreateFromString(obj.mac_address);
	}
}

export class Win32_NetworkAdapterConfigTable extends InfoSet {
	//public static FromJson(json: InfoSetEntriesJson<Win32_NetworkAdapterConfigEntryJsonWrapper>, device: Device): Win32_NetworkAdapterConfigTable {
	//    var result = new Win32_NetworkAdapterConfigTable(device);

	//    json.entries.forEach((jsonEntry) => {
	//        var entry = new Win32_NetworkAdapterConfigEntry();
	//        entry.Deserialize(jsonEntry.win32_network_adapter_config_entry);
	//        result.Add(entry);
	//    });

	//    return result;
	//}

	private _netAdapterConfigTable: List<Win32_NetworkAdapterConfigEntry>;

	constructor(device: Device) {
		super(device);
		this._netAdapterConfigTable = new List<Win32_NetworkAdapterConfigEntry>();
	}

	public Add(configEntry: Win32_NetworkAdapterConfigEntry): boolean {
		if (configEntry == null)
			return false;

		var newEntry: Win32_NetworkAdapterConfigEntry = null;

		if (configEntry.HasIndex)
			newEntry = this.FindByIndex(configEntry.Index);

		if (newEntry == null) {
			this._netAdapterConfigTable.Add(configEntry);
			return true;
		}

		return false;
	}

	public Clear(): void {
		this._netAdapterConfigTable.Clear();
	}

	public get Count(): number {
		return this._netAdapterConfigTable.Count;
	}


	public get HasIpAddresses(): boolean {
		return true;
	}

	public get IpAddresses(): HashSet<IpAddress> {
		var ipAddresses = new HashSet<IpAddress>();

		this._netAdapterConfigTable.ForEach((configEntry: Win32_NetworkAdapterConfigEntry) => {
			if (!configEntry.HasIPAddresses)
				return;
			ipAddresses.UnionWith(configEntry.IPAddresses);
		});

		return (ipAddresses);
	}


	public get HasMacAddresses(): boolean {
		return true;
	}

	public get MacAddresses(): HashSet<MacAddress> {
		var macAddresses = new HashSet<MacAddress>();

		this._netAdapterConfigTable.ForEach((adapterEntry) => {
			if (!adapterEntry.HasMacAddress)
				return;
			if (!adapterEntry.MacAddress.IsValidAddress)
				return;

			macAddresses.Add(adapterEntry.MacAddress);
		});

		return (macAddresses);
	}


	public FindByIndex(index: number): Win32_NetworkAdapterConfigEntry {
		var foundEntry: Win32_NetworkAdapterConfigEntry = null;

		this._netAdapterConfigTable.ForEach((entry) => {
			if (!entry.HasIndex)
				return;

			if (entry.Index != index)
				return;

			foundEntry = entry;
		});

		return (foundEntry);
	}

	public Remove(configEntry: Win32_NetworkAdapterConfigEntry): void {
		this._netAdapterConfigTable.Remove(configEntry);
	}

	public GetDhcpServers(): HashSet<IpAddress> {
		var dhcpServers = new HashSet<IpAddress>();

		this._netAdapterConfigTable.ForEach((configEntry) => {
			if (!configEntry.HasDHCPServer)
				return;

			dhcpServers.Add(configEntry.DHCPServer);
		});

		return dhcpServers;
	}

	public ForEach(callbackfn: (value: Win32_NetworkAdapterConfigEntry, index: number, array: Win32_NetworkAdapterConfigEntry[]) => void, thisArg?: any): void {
		this._netAdapterConfigTable.ForEach(callbackfn, thisArg);
	}

	public Write(obj: any, context: any): void {
		if (this._netAdapterConfigTable.Count > 0) {
			obj.w32_net_ad_cfg_info = {};
			obj = obj.w32_net_ad_cfg_info;

			obj.entries = [];
			ObjSerUtils.WriteObjSerCollection(obj.entries, this._netAdapterConfigTable, context);
		}
	}

	public Read(obj: any, context: any): void {
		if (!obj.w32_net_ad_cfg_info)
			throw new Error();
		obj = obj.w32_net_ad_cfg_info;

		this.Clear();

		if (obj.entries !== undefined) {
			obj.entries.forEach((value: any) => {
				let entry = new Win32_NetworkAdapterConfigEntry();
				entry.Read(value, context);
				this.Add(entry);
			}, this);
		}
	}
}
